import React from 'react';
import SearchTable from './SearchTable.js';
import Popup from './Popup.js';
import db from './db';
import ErrorBoundary from './ErrorBoundary';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import OrderDetailTable from './OrderDetailTable'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ExecuteScriptPopupButton from "./ExecuteScriptPopupButton"
import SearchPopupButton from "./SearchPopupButton"
import FacilityPopup from './FacilityPopup.js';
var functions = require("./functions.js");
var tableColumnRender = require("./TableColumnRender.js")

// HubspotDealTable component
export default class HubspotDealTable extends React.Component {

    // constructor
    constructor(props) {
        super(props);
        this.hubspotDealTableRef = React.createRef();
        let cols=[];
        try{
            //cols.push({ key: 'dealqueue_label', title : "Queue", width :20, default_cookie_label:'deal_queue' });
            cols.push({ key: 'search_column', title:"Search", width :40, noedit:true, doNotDisplayInTable:true});
            cols.push({ key: 'dealname', title:"Deal Name" , noquery:true});
            //cols.push({ key: 'display_full_address',title:'ship address', width :40, noquery:true});
            //cols.push({ key: 'hubspot_deal_id', title:"Deal Id", width :40, noquery:true});
            //cols.push({ key: 'pipeline_label', title:"Pipeline", width:50, noquery:true} );
            //cols.push({ key: 'dealstage_label', title : "Stage", width :20, noquery:true });
            cols.push({ key: 'closed', title : "Is Closed", width :20, noquery:true });
            //cols.push({ key: 'createdate', title:"Created", width:30, noquery:true} );  
            //cols.push({ key: 'closedate', title:"Closed", width :40, noquery:true});
            cols.push({ key: 'last_update_to_fulfilment', title : "Last Item Added", width :20, noquery:true });
            //cols.push({ key: 'hs_deal_stage_probability', title:"Deal Stage Probability", width :40, noquery:true});
            //cols.push({ key: 'hs_priority', title:"Priority", width :40, noquery:true});
            //cols.push({ key: 'deal_line_item_count', title:"Line Item Count", width :40, noquery:true});
            //cols.push({ key: 'amount', title:"Amount", width :40, noquery:true});
            cols.push({ key: 'outbound_delivery_status_hubspot', title:"Delivery Status", width :40, noquery:true});
            cols.push({ key: 'unk1', title:"Deal", width :40, noquery:true, render:tableColumnRender.renderHubspotDealLink.bind(this)});
            cols.push({ key: 'katana_so_link', title : "Katana Link", width :20, default_cookie_label:'katana_so_link_label', render:tableColumnRender. renderKatanaLink.bind(this)});
        } catch (ex){}        
        this.state={
            postObj:[],
            edited:false,
            selectedObject:false,
            columns:cols,
            orderAddress:{},
            hubSpotCompanyAssign:false,
            hubSpotCompany:{},
            facilityPopupId:false,
            initDealId:this.props.initDealId
        };

    }
    componentDidMount(prevProps) {
        if(this.props.searchColumn){
            //document.getElementById("searchTableInputsearch_column").value=this.props.searchColumn;
            //if(this.props.searchColumn && this.props.searchColumn!=""){
            //    this.hubspotDealTableRef.current.queryData();
            //}
            
        }  
        if(this.state.initDealId){
            document.getElementById("searchTableInputsearch_column").value=this.state.initDealId;
            setTimeout(() => { 
                    this.queryData();
                    functions.sleep(1000).then(() => {
                        this.showEditScreen(this.hubspotDealTableRef.current.state.data[0])
                    });
                    
            }, 2000);    
        } else {
            setTimeout(() => { 
                    this.queryData();
            }, 500);    
        }
    }
    queryData(){
        this.hubspotDealTableRef.current.queryData();
    }
    // render
    render() {
        let qry="api/get/hubSpotDealList?";  
        let katanaOrderId = this.state.selectedObject.katana_order_id;

        let hubspotLineItemsCount=0;
        try{
            hubspotLineItemsCount=this.state.selectedObject.lineItem.length
        } catch (ex){}

        let katanaLineItemsCount=0;
        try{
            katanaLineItemsCount=this.state.selectedObject.katanalineItem.length
        } catch (ex){} 

        let outboundTrackingNumber=this.state.selectedObject.tracking_number;
        let outboundTrackingCSS='';
        let outTrack=this.state.selectedObject.tracking_number === null ? "" : this.state.selectedObject.tracking_number;
        if(outTrack!=this.state.selectedObject.outbound_tracking_number_calc){
            outboundTrackingNumber=outTrack + " needs to be changed to "
                + this.state.selectedObject.outbound_tracking_number_calc;
            outboundTrackingCSS='error';
        }
        let inboundTrackingNumber=this.state.selectedObject.inbound_tracking_number;
        let inboundTrackingCSS='';
        let inTrack=this.state.selectedObject.inbound_tracking_number === null ? "" : this.state.selectedObject.inbound_tracking_number;
        if(inTrack!=this.state.selectedObject.inbound_tracking_number_calc){
            inboundTrackingNumber=inTrack + " needs to be changed to "
                + this.state.selectedObject.inbound_tracking_number_calc;
            inboundTrackingCSS='error';
        }
        let hubspotCompanyError=0;
        if(this.state.selectedObject){
            this.state.selectedObject.company.forEach( (company)=>{
                if(company.association_type=='deal_location_facility'){hubspotCompanyError++}
            })
            if (hubspotCompanyError==1){
                hubspotCompanyError=""
            } else {
                hubspotCompanyError=`there are ${hubspotCompanyError} deal_location_facility`
            }
        }
        let hubspotContactError=0;
        if(this.state.selectedObject){
            this.state.selectedObject.contact.forEach( (contact)=>{
                if(contact.association_type=='ship_to'){hubspotContactError++}
            })
            if (hubspotContactError==1){
                hubspotContactError=""
            } else {
                hubspotContactError=`there are ${hubspotContactError} ship_to`
            }
        }
        return (true)?(
            <div className='relative-div'>
                <h2>HubSpot Deals</h2>
                <div className="align-right">
                    <a target="new" href="https://drive.google.com/drive/folders/15T5QhIS7Amv5Gos4NLE9FTVBd5VEEGZG">Hubspot Documentation</a>&nbsp;&nbsp;
                    <a target="new" href="https://docs.google.com/spreadsheets/d/1Py1veTzZCMokfV-SoWLQIbt6vNg_-yc1t2HolirS0wQ/edit?gid=676683481#gid=676683481">Hubspot Rationalization</a>&nbsp;&nbsp;
                    <a target="new" href="https://community.hubspot.com/t5/Account-Settings/where-do-I-find-my-Hub-ID/m-p/647149#:~:text=To%20find%20your%20Hub%20ID,Hope%20this%20helps!">Hubspot Portal Id:</a>
                    <input id="HubSpotPortalId" className='search-table-input' onChange={this.updateHubspotPortalId.bind(this)} defaultValue={functions.getHubspotPortalId()}></input>
                    <a target="new" href="https://app.hubspot.com/">Hubspot</a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a target="new" href="https://apps.goshippo.com/">shippo</a>&nbsp;
                    <a target="new" href="https://docs.google.com/spreadsheets/d/1Py1veTzZCMokfV-SoWLQIbt6vNg_-yc1t2HolirS0wQ/edit?gid=676683481#gid=676683481">notes</a>
                </div>
                <SearchTable
                    query={this.props.securityObject.httpServer+qry}
                    columns={this.state.columns}
                    securityObject={this.props.securityObject}
                    tableHeight="70vh"
                    key="tableAddEditSearchTable"
                    onClick={this.showEditScreen.bind(this)}
                    ref={this.hubspotDealTableRef}
                    afterQuery={this.props.afterQuery}
                >
                </SearchTable>
                <Popup trigger={this.state.selectedObject} afterClose={this.afterClosePopup.bind(this)}>
                            <div className="align-right">
                                <button onClick={() => this.closePopup()}>
                                    x
                                </button>  
                            </div>
                            <Tabs onSelect={(index) => {
                                if(index=1){
                                    this.refreshScreen();
                                }
                            }

                            }>
                            <TabList>
                                <Tab>Header</Tab>
                                <Tab disabled={this.state.selectedObject.id===-1}>Detail</Tab>
                            </TabList>
                            <TabPanel>
                                <div style={{ height:"90vh" }}>
                                    <table>
                                        <tr>
                                            <td width="600px" className='plain'>
                                            <label className='label'>HubSpot Deal Id</label>{this.state.selectedObject.hubspot_deal_id}
                                            &nbsp;
                                            <button className="" title="Copy value to clipboard" 
                                                onClick={() => functions.copyToClipBoard(this.state.selectedObject.hubspot_deal_id) }>
                                                <img alt='copy' height="15px" src="icons8-clone-figure-32.png"></img>
                                            </button>
                                            <button target="new" onClick={()=>this.showHubspotDeal("")}>Deal</button>
                                            <button onClick={()=>{ this.refreshScreen()}}>Refresh</button>
                                            <ExecuteScriptPopupButton
                                                    securityObject={this.props.securityObject}
                                                    buttonLabel="Reload"
                                                    screenLabel="Reload this deal data (deal,company,contact) in Device App with latest data from HubSpot"
                                                    onClose={()=>this.refreshScreen()}
                                                    url={ `api/reloadDeal?hubspot_deal_id=${this.state.selectedObject.hubspot_deal_id}`
                                                            +`&hubspot_company_id=${this.state.selectedObject.hubspot_company_id}`
                                                            +`&hubspot_contact_id=${this.state.selectedObject.hubspot_contact_id}`
                                                            +`&katana_order_id=${this.state.selectedObject.katana_order_id}`
                                                            +`&user=${this.props.securityObject.userName}`}
                                                >
                                            </ExecuteScriptPopupButton>
                                            <br />
                                            <label className='label'>Deal</label>{this.state.selectedObject.dealname}<br />
                                                <label className='label'>Pipeline</label>{this.state.selectedObject.pipeline_label}<br />
                                                <label className='label'>Stage</label>{this.state.selectedObject.dealstage_label}<br />
                                                <label className='label'>
                                                    <span className={ this.state.selectedObject.facility_id==0
                                                        || this.state.selectedObject.facility_id==null? "error" : "" }>
                                                        Facility
                                                    </span>                                                    
                                                </label>
                                                    <span className={ this.state.selectedObject.facility_id==0
                                                        || this.state.selectedObject.facility_id==null? "error" : "" }>
                                                        {this.state.selectedObject.facility_id}-{this.state.selectedObject.facility_name}
                                                    </span>
                                                <br></br>
                                                <SearchPopupButton
                                                        securityObject={this.props.securityObject}
                                                        buttonLabel='Facility LookUp'
                                                        title='Search Facility for this Order (if facility is not found you may need to close window and "Create Facility from HubSpot Company")'
                                                        query={this.props.securityObject.httpServer + "api/get/facilitySearch?"}
                                                        onClick={this.selectFacility.bind(this)}
                                                        columns={[
                                                                //{ key: 'id', title:"Facility id", width :20, noquery:true }
                                                                { key: 'display_name', title:"name", width :40, noquery:true }
                                                                ,{ key: 'hubspot_company_id', title:"Hubspot Company Id", width :40, noquery:true, render:tableColumnRender.renderHubspotCompanyLink.bind(this) }
                                                                ,{ key: 'id', title:"Facility Id", width :40, noquery:true }
                                                                ,{ key: 'source', title:"source", width :40, noquery:true }
                                                                ,{ key: 'display_address', title:"address", width :40, noquery:true }
                                                                ,{ key: 'display_city', title:"city", width :40, noquery:true }
                                                                ,{ key: 'display_state', title:"state", width :40, noquery:true }
                                                                ,{ key: 'display_zip', title:"zip", width :40, noquery:true }
                                                                ,{ key: 'search_column', title:"Search", noedit:true, doNotDisplayInTable:true}
                                                                ]}
                                                    ></SearchPopupButton>
                                                    <button onClick={()=>{ this.createFacility()}}>Create Facility for Hubspot Company</button>
                                                    <button onClick={()=>{ this.displayFacility()}}>Display Facility</button>
                                                <br />

                                                <label className='label'>Queue</label>{this.state.selectedObject.dealqueue_label}<br />
                                                <label className='label'>Is Closed</label>{this.state.selectedObject.closed}<br />
                                                <label className='label'>Created</label>{this.state.selectedObject.createdate}<br />
                                                <label className='label'>Closed</label>{this.state.selectedObject.closedate}<br />

                                                <label className='label'>OutBound Tracking</label><div className={outboundTrackingCSS}>{outboundTrackingNumber}</div><br />
                                                <pre>{this.state.selectedObject.outbound_delivery_status_text}</pre>
                                                <label className='label'>Inbound Tracking</label><div className={inboundTrackingCSS}>{inboundTrackingNumber}</div><br />
                                                <pre>{this.state.selectedObject.inbound_delivery_status_text}</pre>
                                                
                                                <label className='label'>Deal Stage Probability</label>{this.state.selectedObject.hs_deal_stage_probability}<br />
                                                <label className='label'>Priority</label>{this.state.selectedObject.hs_priority}<br />
                                                <label className='label'>Amount</label>{this.state.selectedObject.amount}<br />
                                                <label className='label'>
                                                    <span className={ this.state.selectedObject.katana_order_no === this.state.selectedObject.hubspot_deal_id ? "" : "error" }>
                                                        Katana Order No(same as deal no)
                                                    </span>
                                                </label>
                                                <span className={ this.state.selectedObject.katana_order_no === this.state.selectedObject.hubspot_deal_id ? "" : "error" }>{this.state.selectedObject.katana_order_no}</span><br />
                                                <label className='label'>Katana Link</label><a href={this.state.selectedObject.katana_so_link} target='_blank'>link {katanaOrderId}</a>
                                                <br />
                                                <button target="new" onClick={()=>this.showHubspotDeal("#card-wrapper-203582570")}>Hubspot Deal</button>
                                                <button onClick={()=>{ this.refreshScreen()}}>Refresh</button>                                          
                                                <ExecuteScriptPopupButton
                                                        securityObject={this.props.securityObject}
                                                        buttonLabel="Import From Katana"
                                                        screenLabel="Executing Katana Import..."
                                                        onClose={()=>this.refreshScreen()}
                                                        url={`api/importKatanaIntoDeal?hubspot_deal_id=${this.state.selectedObject.hubspot_deal_id}&katana_order_id=${katanaOrderId}`}
                                                    >
                                                </ExecuteScriptPopupButton>   
                                                <br />
                                                <label className='label'>Katana PO</label>{this.state.selectedObject.katana_po}<br />

                                                <br />
                                                <label>Deal Address </label>
                                                {this.state.orderAddress.display_name}<br/>
                                                {this.state.orderAddress.display_contact_name}<br/>
                                                {this.state.orderAddress.display_phone}<br/>
                                                {this.state.orderAddress.display_email}<br/>
                                                <span className={ this.state.orderAddress.display_full_address 
                                                    && this.state.orderAddress.display_full_address.includes("null") ? "error" : "" }>
                                                        {this.state.orderAddress.display_full_address}
                                                </span>
                                                <button target="new" onClick={()=>this.showHubspotDeal("#card-wrapper-222989998")}>Hubspot Deal</button>
                                                <button onClick={()=>{ this.refreshScreen()}}>Refresh</button>                                          
                                                <br/>
                                            </td>
                                            <td className='plain'>
                                            <label>Line Items (HubSpot {hubspotLineItemsCount})</label>
                                            <br />
                                            <TableScrollbar height="40vh">
                                                    <ErrorBoundary>
                                                        <Table columns={[
                                                                { key: 'name_description', title:"Description", width:50 , noquery:true, noedit:true,render:tableColumnRender.renderMultiLineText} 
                                                                ,{ key: 'hs_sku', title:"SKU", width:10 , noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard} 
                                                                ,{ key: 'quantity', title : "quantity", width :10, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard}
                                                                ]} 
                                                                dataSource={this.state.selectedObject.lineItem} 
                                                                />
                                                    </ErrorBoundary>
                                                </TableScrollbar>                         
                                            </td>
                                            <td className='plain'>
                                            <label>Line Items (Katana {katanaLineItemsCount})</label>
                                            <br />
                                            <TableScrollbar height="40vh">
                                                    <ErrorBoundary>
                                                        <Table columns={[
                                                                { key: 'katana_name', title:"Description", width:50 , noquery:true, noedit:true,render:tableColumnRender.renderMultiLineText} 
                                                                ,{ key: 'sku', title:"SKU", width:10 , noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard} 
                                                                ,{ key: 'quantity', title : "quantity", width :10, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard}
                                                                ,{ key: 'serial_number', title : "serial number", width :10, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard}
                                                                ,{ key: 'device_app_item_type', title : "item type", width :10, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard}
                                                                ]} 
                                                                dataSource={this.state.selectedObject.katanalineItem} 
                                                                />
                                                    </ErrorBoundary>
                                                </TableScrollbar>                         
                                            </td>
                                        </tr>
                                    </table>
                                    <label>HubSpot Companies</label><error>{hubspotCompanyError}</error>
                                    <br />
                                    <TableScrollbar height="20vh">
                                        <ErrorBoundary>
                                            <Table columns={[
                                                    { key: 'association_type', title:"type", width :40, noquery:true }
                                                    ,{ key: 'name', title:"name" , noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard}
                                                    ,{ key: 'organization_category', title:"category" , noquery:true, noedit:true}
                                                    ,{ key: 'address', title:"address", width:50 , noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard} 
                                                    ,{ key: 'address2', title:"address2", width:50 , noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard} 
                                                    ,{ key: 'city', title:"city", width:50 , noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard} 
                                                    ,{ key: 'state', title : "state", width :20, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard}
                                                    ,{ key: 'zip', title : "zip", width :20, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard}
                                                    ,{ key: 'phone', title : "phone", width :20, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard}
                                                    ,{ key: 'hubspot_company_object_id', title:"Hubspot Company", width:10 , noquery:true, noedit:true, render:tableColumnRender.renderHubspotCompanyLink.bind(this)}
                                                    //,{ key: 'search_column', title:"Search", width:10 , noedit:true,render:tableColumnRender.renderProcessOrder.bind(this)} 
                                                ]} 
                                                    dataSource={this.state.selectedObject.company} 
                                                    />
                                        </ErrorBoundary>
                                    </TableScrollbar>                                 
                                    <label>HubSpot Contacts </label><error>{hubspotContactError}</error>
                                    <br />
                                    <TableScrollbar height="20vh">
                                        <ErrorBoundary>
                                            <Table columns={[
                                                { key: 'association_type', title:"type", width :40, noquery:true }
                                                ,{ key: 'full_name', title:"Name" , noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard}
                                                ,{ key: 'phone', title : "Phone", width :20, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard}
                                                ,{ key: 'email', title:"EMail", width:30, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard} 
                                                ,{ key: 'jobtitle', title:"Job Title", editClassName:"hidden", width :40, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard }
                                                ,{ key: 'hubspot_contact_id', title:"Hubspot Contact", width:10 , noquery:true, noedit:true, render:tableColumnRender.renderHubspotContactLink.bind(this)}
                                                //,{ key: 'search_column', title:"Search", width:10 , noedit:true,render:tableColumnRender.renderProcessOrder.bind(this)} 
                                            ]}
                                                    dataSource={this.state.selectedObject.contact} 
                                                    />
                                        </ErrorBoundary>
                                    </TableScrollbar>                            
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <error>
                                    {this.state.selectedObject.rma_needed=="true"?"RMA Needed:"+this.state.selectedObject.rma_needed:""}
                                </error>
                                <OrderDetailTable 
                                    securityObject={this.props.securityObject}
                                    orderId={this.state.selectedObject.hubspot_deal_id}
                                    sourceOrderId={this.state.selectedObject.hubspot_deal_id}
                                    orderType="HSD"
                                    lineItem={this.state.selectedObject.lineItem}
                                    orderAddress={this.state.orderAddress}
                                    facilityId={this.state.selectedObject.facility_id}
                                    facilityName={this.state.selectedObject.facility_name}                                    
                                ></OrderDetailTable>                                   
                            </TabPanel>
                        </Tabs>
                </Popup>   

                <Popup trigger={this.state.hubSpotCompanyAssign}>
                    Assign HubSpot Company
                    <div className="align-right">
                        <button onClick={() => this.setState({hubSpotCompanyAssign:false})}>
                            x
                        </button>  
                    </div>
                    Find an existing facility to make a 1 to 1 connection to HubSpot Company {this.state.hubSpotCompany.name} &nbsp;
                    {this.state.hubSpotCompany.city} &nbsp;
                    {this.state.hubSpotCompany.state}.<br />
                    If the facility is already assigned to another HubSpot Company you may not use it.<br />
                    If you can not find a facility you may create a new one.<br />
                    <button onClick={this.createCompany.bind(this)}>Create New Facility for this HubSpot Company</button>
                    <SearchTable
                                securityObject={this.props.securityObject}
                                query={this.props.securityObject.httpServer + "api/get/facility?"}
                                columns={[
                                        { key: 'id', title:"facility ID", width :40, noquery:true }
                                        ,{ key: 'facility_name', title:"facility name", width :40, noquery:true }
                                        ,{ key: 'facility_city', title:"facility_city", width :40, noquery:true }
                                        ,{ key: 'facility_address', title:"facility_address", width :40, noquery:true }
                                        ,{ key: 'hubspot_company_name', title:"Hubpot Company Assigned", width :40, noquery:true }
                                        ,{ key: 'hubspot_company_city', title:"city", width :40, noquery:true }
                                        ,{ key: 'hubspot_company_hubspot_owner_id', title:"Company ID", width :40, noquery:true }
                                        ,{ key: 'display_contact_name', title:"Contact", width :40, noquery:true }
                                        ,{ key: 'display_email', title:"Email", width :40, noquery:true }
                                        //,{ key: 'search_column', title:"Search", width:10 , noedit:true, doNotDisplayInTable:true}
                                        ]}
                                onClick={this.assignCompany.bind(this)}
                                tableHeight="60vh"
                            >
                    </SearchTable>                  
                </Popup>
                <FacilityPopup 
                    facilityId={this.state.facilityPopupId}
                    visible={this.state.facilityPopupId}
                    securityObject={this.props.securityObject}
                    onCloseFacilityPopup={this.closeFacilityPopup.bind(this)}
                >
                </FacilityPopup>   
            </div>
        ):"";
    }

    assignCompany( rowData, cellData, rowIndex){
        if(rowData.hubspot_company_id){
            alert( '"'+rowData.facility_name + '" is already assigned to "' + rowData.hubspot_company_name +'" you may not assign it to another facility.')
        } else {
            if(window.confirm(`Are you sure you want to assign facility ${rowData.facility_name} to HubSpot Company ${this.state.hubSpotCompany.name} `)){
                let thisApp=this;
                db.saveData( this.props.securityObject
                    , {id:rowData.id, hubspot_company_id:this.state.hubSpotCompany.hubspot_object_id}
                    ,"api/updateFacility"
                    , function(result){
                        thisApp.setState({
                            hubSpotCompanyAssign:false
                            ,selectedObject:false
                        });
                        thisApp.queryData();
                    });
        
            }
        }
    }
    afterClosePopup(){
    }
  
    showEditScreen(rowData){

        db.getHubspotDeal(
            rowData.hubspot_deal_id 
            ,this.props.securityObject
            , (deal)=>{
                    let streetAddress2="";
                    let orderAddress="";
                    if(deal){
                        if(deal.shipping_street_address_2){
                            streetAddress2=deal.shipping_street_address_2+"\n"
                        }
                        orderAddress={
                            display_name:deal.company_name,
                            display_contact_name:"",
                            display_phone:"",
                            display_email:"",
                            display_address:deal.shipping_street_address,
                            display_address2:deal.shipping_street_address_2,
                            display_city:deal.shipping_city,
                            display_state:deal.shipping_state,
                            display_zip:deal.shipping_postal_code,
                            display_country:deal.shipping_country,
                            shipping_notes:deal.shipping_notes,
                            display_full_address:
                                deal.shipping_street_address+"\n"
                                +streetAddress2
                                +deal.shipping_city+", "
                                +deal.shipping_state+" "
                                +deal.shipping_postal_code+" "
                                +deal.shipping_country,
                            display_contact_name:deal.contact_fullname,
                            display_phone:deal.contact_phone,
                            display_email:deal.contact_email,
                            reference_1_in:"rma:"+deal.hubspot_deal_id,
                            reference_2_in:"",
                            reference_1_out:"deal:"+deal.hubspot_deal_id,
                            reference_2_out:""
                        }
                        this.setState({
                            selectedObject:deal
                            ,orderAddress:orderAddress
                        })                        
                    } else {
                        alert("Cannot find HubSpot Deal "+ rowData.hubspot_deal_id);
                    }
        });
    }
    // close the popup
    closePopup(){
        this.setState({
            selectedObject:false
        });
    }    

    // set the cookie to change the Bad Battery Threshold
    updateHubspotPortalId(e){
        this.setState({
            proxyPort:e.target.value
        })
        functions.saveCookieValue('HubspotPortalId',e.target.value)
    } 
    

    showHubspotDeal(extra){
        let portalId=functions.getHubspotPortalId();
        functions.openWindow(`https://app.hubspot.com/contacts/${portalId}/record/0-3/${this.state.selectedObject.hubspot_deal_id}${extra}`);
    }

    renderAssignHubspotCompanyToFacility(cellData, rowData, rowIndex){
        let array=[];
        if(cellData==="" || cellData===undefined){
            let btnPlus=React.createElement(
                'button'
                ,{  onClick: (event) => 
                    {   
                        this.setState({
                            hubSpotCompanyAssign:true
                            ,hubSpotCompany: rowData
                        })
                    }
                    ,key:"buttonLink"+rowData.id
                }
                ,"Assign Facility");
            array.push(btnPlus);
        } else {
            let btnPlus=React.createElement(
                'pre'
                ,{ }
                ,cellData+" "+rowData.facility_name);
            array.push(btnPlus);
        }
        // return div
        let div=React.createElement('div',{}, array );
        return div;    
    }
    createCompany(){
        if(window.confirm(`Are you sure you want to create a new facility for HubSpot company ${this.state.hubSpotCompany.name}`)){
            let thisApp=this;
            db.saveData( this.props.securityObject
                , {id:-1
                    , hubspot_company_id:this.state.hubSpotCompany.hubspot_object_id
                    ,facility_name:this.state.hubSpotCompany.name
                    ,facility_type:"commercial"
                }
                ,"api/updateFacility"
                , function(result){
                    thisApp.setState({
                        hubSpotCompanyAssign:false
                        ,selectedObject:false
                    });
                    thisApp.queryData();
                });
        }
    }
    createFacility(){
        if(confirm(`Are you sure you want to create a new facility for HubSpot company `)){
            let thisApp=this;
            db.saveData( this.props.securityObject
                , {
                    hubspot_company_id:this.state.selectedObject.hubspot_company_id,
                    facility_name:this.state.selectedObject.company_name,
                    facility_type:"commercial"
                }
                ,"api/updateFacility"
                , function(result){
                    thisApp.refreshScreen();
                });
        }
    }
    displayFacility(){
        this.setState({
            facilityPopupId:this.state.selectedObject.facility_id
        })        
    }
    refreshScreen(){
        this.showEditScreen({hubspot_deal_id:this.state.selectedObject.hubspot_deal_id});
    }    
    closeFacilityPopup(){
        this.setState({
            facilityPopupId:undefined
        })
    }    
    selectFacility(rowData){
        this.setState({facilityPopupId:rowData.id});
        this.refreshScreen();
    }
}